// Widget Scripts
import videoWidget from './js/widgets/videoWidget';
import seoWidget from './js/widgets/seoWidget';
import activitiesWidget from './js/widgets/activitiesWidget';
import flowersWidget from './js/widgets/flowersWidget';
import * as socialNetworkWidget from './js/widgets/socialNetworkWidget';
import footerButtonsWidget from './js/widgets/footerButtonsWidget';
import topBackgroundWidget from './js/widgets/topBackgroundWidget';

// Custom Theme Scripts
import './js/localjs';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(() => {
    seoWidget();
    flowersWidget();
    activitiesWidget();
  });
  $(window).load(() => {
    socialNetworkWidget.instafeed(true);
    videoWidget();
  });

  let flowersWidgetResized = false;
  $(window).resize(() => {
    if (window.innerWidth <= 992 && !flowersWidgetResized) {
      flowersWidget();
      flowersWidgetResized = true;
    } else if (window.innerWidth > 992 && flowersWidgetResized) {
      flowersWidget();
      flowersWidgetResized = false;
    }
  });
}

$(document).ready(() => {
  footerButtonsWidget();
});
